import { useState } from 'react';

interface ReviewFormProps {
  walkId: string;
  onReviewSubmitted?: () => void;
}

const ReviewForm: React.FC<ReviewFormProps> = ({ walkId, onReviewSubmitted }) => {
  const [user, setUser] = useState('');
  const [stars, setStars] = useState(5);
  const [comment, setComment] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');

    try {
      const res = await fetch(`/api/reviews/${walkId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user, stars, comment }),
      });

      if (!res.ok) {
        throw new Error('Failed to submit review');
      }

      setUser('');
      setStars(5);
      setComment('');
      if (onReviewSubmitted) onReviewSubmitted();
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} style={{
      backgroundColor: '#fff',
        padding: '20px',
        borderRadius: '10px',
        width: '90%',
        maxWidth: '500px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
        maxHeight: '90vh', // ✅ prevents overflow
        overflowY: 'auto'  // ✅ enables internal scroll if needed
    }}>
      <h3 style={{ margin: 0, fontSize: '1.4em' }}>🐾 Leave a Doggy Review</h3>

      {error && <p style={{ color: 'red', margin: 0 }}>{error}</p>}

      <label style={{ display: 'flex', flexDirection: 'column' }}>
        Your Name:
        <input
          value={user}
          onChange={e => setUser(e.target.value)}
          required
          style={{
            padding: '8px',
            borderRadius: '6px',
            border: '1px solid #ccc',
            marginTop: '4px'
          }}
        />
      </label>

      <label style={{ display: 'flex', flexDirection: 'column' }}>
        Rating:
        <select
          value={stars}
          onChange={e => setStars(Number(e.target.value))}
          style={{
            padding: '8px',
            borderRadius: '6px',
            border: '1px solid #ccc',
            marginTop: '4px'
          }}
        >
          {[1, 2, 3, 4, 5].map(n => (
            <option key={n} value={n}>{n} 🐾</option>
          ))}
        </select>
      </label>

      <label style={{ display: 'flex', flexDirection: 'column' }}>
        Comment:
        <textarea
          value={comment}
          onChange={e => setComment(e.target.value)}
          required
          rows={4}
          style={{
            padding: '8px',
            borderRadius: '6px',
            border: '1px solid #ccc',
            marginTop: '4px',
            resize: 'vertical'
          }}
        />
      </label>

      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
        <button
          type="submit"
          disabled={submitting}
          style={{
            padding: '8px 16px',
            backgroundColor: '#2196f3',
            color: '#fff',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer'
          }}
        >
          {submitting ? 'Submitting...' : 'Submit Review'}
        </button>
        <button
          type="button"
          onClick={onReviewSubmitted}
          style={{
            padding: '8px 16px',
            backgroundColor: '#eee',
            border: '1px solid #ccc',
            borderRadius: '6px',
            cursor: 'pointer'
          }}
        >
          Close
        </button>
      </div>
    </form>
  );
};

export default ReviewForm;
